import { render, staticRenderFns } from "./ContainerNotes.vue?vue&type=template&id=570c25d2&"
import script from "./ContainerNotes.vue?vue&type=script&lang=js&"
export * from "./ContainerNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports